<template>
  <v-card elevation="0" rounded="0">
    <DrawerToolbar title="Add to mobile wallet" @close="closeWallet" />

    <div class="slide-group-button text-center mt-12 ml-6">
      <v-btn
        depressed
        small
        width="140"
        height="30"
        :color="activeTab == keys.ios ? 'white' : 'lightGrey'"
        class="mr-1"
        :class="{
          'slide-button': activeTab == keys.ios,
        }"
        @click="activeTab = keys.ios"
      >
        iOS
      </v-btn>
      <v-btn
        depressed
        small
        width="140"
        height="30"
        :color="activeTab == keys.android ? 'white' : 'lightGrey'"
        class="ml-1"
        :class="{
          'slide-button': activeTab == keys.android,
        }"
        @click="activeTab = keys.android"
      >
        Android
      </v-btn>
    </div>
    <div v-if="activeTab == keys.ios" key="0" class="mt-5">
      <v-stepper vertical class="elevation-0" v-model="defaultStepper">
        <v-stepper-step :complete="true" step="1" complete-icon="mdi-numeric-1">
          Open the Wallet app on your iOS device
        </v-stepper-step>
        <v-stepper-content step="1"></v-stepper-content>
        <v-stepper-step :complete="true" step="2" complete-icon="mdi-numeric-2">
          Tap the + to add a new payment card
        </v-stepper-step>
        <v-stepper-content step="2"></v-stepper-content>

        <v-stepper-step :complete="true" step="3" complete-icon="mdi-numeric-3">
          From the Add to Wallet menu, tap 'Debit or Credit Card'
        </v-stepper-step>
        <v-stepper-content step="0" class="text-left">
          <small> Then click 'Continue'</small>
        </v-stepper-content>
        <v-stepper-content step="0" class="text-left"></v-stepper-content>

        <!-- On Mobile -->
        <v-stepper-step :complete="true" step="4" complete-icon="mdi-numeric-4">
          Point your phone camera at the card or tap 'Enter card details manually' then copy the
          card number from this page and paste it into the form
        </v-stepper-step>
        <v-stepper-content step="0" class="text-left"> </v-stepper-content>

        <v-stepper-step :complete="true" step="5" complete-icon="mdi-numeric-5">
          Tap 'Next' then do the same for expiration and cvv
        </v-stepper-step>
        <v-stepper-content step="0" class="text-left"></v-stepper-content>

        <v-stepper-step :complete="true" step="6" complete-icon="mdi-numeric-6">
          Tap 'Next' and agree to Issuer Terms
        </v-stepper-step>
        <v-stepper-content step="0" class="text-left"></v-stepper-content>

        <v-stepper-step :complete="true" step="6" complete-icon="mdi-numeric-7">
          Follow the verification steps
        </v-stepper-step>
        <v-stepper-content step="0" class="text-left"></v-stepper-content>

        <v-stepper-step :complete="true" step="8">
          Your card should now be set up in Apple Pay!
        </v-stepper-step>

        <v-stepper-content step="1" class="py-1"> </v-stepper-content>
      </v-stepper>
    </div>
    <div v-if="activeTab == keys.android" key="1" class="mt-5">
      <v-stepper vertical class="elevation-0" v-model="defaultStepper">
        <v-stepper-step :complete="true" step="1" complete-icon="mdi-numeric-1">
          Open Google Wallet on your Android device
        </v-stepper-step>
        <v-stepper-content step="0" class="text-left">
          <small>
            If you don't have the Google Wallet app, you'll need to download it from the Play
            store</small
          >
        </v-stepper-content>
        <v-stepper-step :complete="true" step="2" complete-icon="mdi-numeric-2">
          Tap "Add a card" to add a new payment card
        </v-stepper-step>
        <v-stepper-content step="2"></v-stepper-content>

        <v-stepper-step :complete="true" step="3" complete-icon="mdi-numeric-3">
          Tap "+ New credit or debit card"
        </v-stepper-step>
        <v-stepper-content step="3"></v-stepper-content>

        <!-- If on mobile -->
        <v-stepper-step :complete="true" step="4" complete-icon="mdi-numeric-4">
          Point your phone camera at the card or tap 'Enter details manually' then copy the card
          number from this page and paste it into Google Wallet
        </v-stepper-step>
        <v-stepper-content step="0" class="text-left"> </v-stepper-content>

        <v-stepper-step :complete="true" step="5" complete-icon="mdi-numeric-5">
          Do the same for expiration and CVC
        </v-stepper-step>
        <v-stepper-content step="0" class="text-left"></v-stepper-content>

        <v-stepper-step :complete="true" step="6" complete-icon="mdi-numeric-6">
          Fill in your billing address, then tap 'Save'
        </v-stepper-step>
        <v-stepper-content step="6" class="text-left"></v-stepper-content>

        <v-stepper-step :complete="true" step="7" complete-icon="mdi-numeric-7">
          Agree to the Issuer Terms
        </v-stepper-step>

        <v-stepper-content step="7" class="text-left"></v-stepper-content>

        <v-stepper-step :complete="true" step="8">
          Your card should now be set up in Google Wallet!
        </v-stepper-step>

        <v-stepper-content step="1" class="py-1"> </v-stepper-content>
      </v-stepper>
    </div>
  </v-card>
</template>

<script>
import DrawerToolbar from "@/components/generic/DrawerToolbar.vue";

export default {
  name: "AddToMobileWalletInstructions",
  components: {
    DrawerToolbar,
  },
  data() {
    return {
      defaultStepper: 0,
      keys: {
        ios: 0,
        android: 1,
      },
    };
  },
  computed: {
    activeTab: {
      get() {
        return this.$store.state.walletInstructionTab;
      },
      set(value) {
        this.$store.dispatch("setWalletInstructionTab", value);
      },
    },
  },
  methods: {
    closeWallet() {
      this.$store.dispatch("setDisplayWalletMenu", false);
    },
  },
};
</script>

<style scoped>
.slide-button.white:hover {
  background-color: #ffffff !important;
}

.white.v-btn:before {
  background-color: #ffffff !important;
}
</style>
